/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


$(document).ready(function() {
  $(document).on('click', '.js-open-quick-view', function(e) {
    e.preventDefault();
    e.stopPropagation();
    console.log("clicked")
    const productId = $(this).data('product-id');
    $('.js-variant-slider').removeClass('is-active');
    $(`#QuickView-${productId}`).addClass('is-active');
    $(`body`).addClass('active_popup');

  });

  $(document).on('click', '.featured-collections .js-open-quick-view', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $body = $('body');

    // Remove active state from other sliders
    $('.mobile-popup-variant .js-variant-slider.is-active').removeClass('is-active');

    // Add popup active class
    $body.addClass('active_popup');

    // Run this only if body has active_popup
    if ($body.hasClass('active_popup')) {
      const productIds = $(this).data('product-id');
      $('.product-list').find('.mobile-popup-variant .js-variant-slider[productId="' + productIds + '"]').addClass('is-active');
    }
  });

   // Close button
  $(document).on('click', '.js-close-slide', function(e) {
    e.stopPropagation();
    $(this).closest('.js-variant-slider').removeClass('is-active');
    $(`body`).removeClass('active_popup');
  });

  // Popup Close button
  $(document).on('click', '.close-modal', function() {
    $('.js-close-slide').trigger('click');
  });

  //  Click outside to close
  $(document).on('click', function () {
    $('.js-variant-slider').removeClass('is-active');
    $(`body`).removeClass('active_popup');
  });
  
  // Prevent closing when clicking inside slider
  $(document).on('click', '.js-variant-slider', function (e) {
    e.stopPropagation();
  });


  $(document).on('change', '.js-variant-radio', function() {
    const $container = $(this).closest('.slider-flex-container');
    $container.find('.js-variant-title').text($(this).data('title'));
  });

  $(document).on('click', '.btn-quantity', function() {
    const $input = $(this).siblings('input');
    const isPlus = $(this).hasClass('qty-plus');
    const val = parseInt($input.val());
    
    if (isPlus) {
      $input.val(val + 1);
    } else if (val > 1) {
      $input.val(val - 1);
    }
  });

  $(document).on('submit', '.js-product-form', function(e) {
    e.preventDefault();
    const $form = $(this);
    const $btn = $form.find('.add-to-cart-btn');
    
    $btn.text('...').prop('disabled', true);

    $.post('/cart/add.js', $form.serialize(), function() {
      $btn.text('ADDED');
      
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));

      setTimeout(() => {
        const miniCart = document.getElementById('mini-cart');
        if (miniCart) miniCart.open = true;
        
        $form.closest('.js-variant-slider').removeClass('is-active');
        $btn.text('ADD').prop('disabled', false);
        $(`body`).removeClass('active_popup');
      }, 800);
    }, 'json').fail(function() {
      $btn.text('ERROR').prop('disabled', false);
      setTimeout(() => $btn.text('ADD'), 2000);
    });
  });
});


// ============= slick slider js ==========
document.addEventListener('DOMContentLoaded', function () {
  $('.slick-product-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: true,
    dots: false,
    infinite: true,
    prevArrow: $('.slick-prev-custom'),
    nextArrow: $('.slick-next-custom'),
    responsive: [
      {
        breakpoint: 1600,
        settings: { slidesToShow: 4 }
      },
      {
        breakpoint: 1025,
        settings: { 
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true
         }
      },
      {
        breakpoint: 768,
        settings: { 
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true
         }
      }
    ]
  });
});

// product image slide
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".custom-image-content");

  // Clone all images once for seamless loop
  if(slider){
    slider.innerHTML += images;
    const images = slider.innerHTML;
  }
});

// product testimonial
document.addEventListener('DOMContentLoaded', function () {
  $('.product-testimonial-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    adaptiveHeight: true,
    variableWidth: false,

    prevArrow: `
      <button type="button" class="slick-prev testimonial-prev testimonial-arrow-button" aria-label="Previous">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="24.000000pt" height="24.000000pt" viewBox="0 0 24.000000 24.000000" preserveAspectRatio="xMidYMid meet" style="
            width: 18px;
        ">
          <g transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
          <path d="M105 180 l-60 -60 63 -62 c49 -49 64 -60 74 -50 10 10 2 23 -37 62
          l-49 50 48 49 c42 42 53 71 28 71 -4 0 -34 -27 -67 -60z"></path>
          </g>
        </svg>
      </button>
    `,

    nextArrow: `
      <button type="button" class="slick-next testimonial-next testimonial-arrow-button" aria-label="Next">
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
          width="24.000000pt" height="24.000000pt"
          viewBox="0 0 24.000000 24.000000"
          preserveAspectRatio="xMidYMid meet"
          style="width: 18px;">

          <g transform="translate(24.000000,0.000000) scale(-0.100000,0.100000)"
            fill="#000000" stroke="none">
            <path d="M105 180 l-60 -60 63 -62 c49 -49 64 -60 74 -50 10 10 2 23 -37 62
              l-49 50 48 49 c42 42 53 71 28 71 -4 0 -34 -27 -67 -60z"></path>
          </g>
        </svg>
      </button>
    `
  });
});

// Cart Drawer

$(document).ready(function () {

  function toggleLoader($container, show) {
    const $loader = $container.closest('line-item.line-item').find('.line-item__loader');
    show ? $loader.removeAttr('hidden') : $loader.attr('hidden', true);
  }

  function getSelectedOptions($container) {
    let selectedOptions = {};
    $container.find('select').each(function () {
      const index = $(this).data('option-index'); 
      const value = $(this).val();
      if (index && value) {
        selectedOptions[`option${index}`] = value;
      }
    });
    return selectedOptions;
  }

  function findMatchingVariant(variants, selectedOptions) {
    return variants.find(variant => {
      return Object.keys(selectedOptions).every(optionKey => {
        return variant[optionKey] === selectedOptions[optionKey];
      });
    });
  }

  function changeVariant($container) {
    const oldVariantId = $container.data('current-variant');
    const quantity = parseInt($container.find('.quantity-selector__input').val() || 1, 10);

    const variants = JSON.parse($container.find('.line-item-variants-json').text());
    const selectedOptions = getSelectedOptions($container);
    const matchedVariant = findMatchingVariant(variants, selectedOptions);

    if (!matchedVariant) {
      console.error('No matching variant found:', selectedOptions);
      return;
    }

    if (matchedVariant.id === oldVariantId) return;

    toggleLoader($container, true);

    console.log("New variant ID:", matchedVariant.id);
    console.log("Old variant ID:", oldVariantId);

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        line: $container.data('line'),
        quantity: 0
      },
      dataType: 'json',
      success: function () {

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            id: matchedVariant.id,
            quantity: quantity
          },
          dataType: 'json',
          success: function () {
            fetch('/cart.js')
              .then(res => res.json())
              .then(cart => {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true,
                  detail: { cart }
                }));
              })
              .finally(() => toggleLoader($container, false));
          },
          error: function () {
            toggleLoader($container, false);
          }
        });

      },
      error: function () {
        toggleLoader($container, false);
      }
    });

  }

  $(document).on('change', '.cart-variant-select, .variant-dropdown', function () {
    const $container = $(this).closest('.cart-variant-options');
    changeVariant($container);
  });

  $(document).on('click', '.edit-btn', function () {
    const select = $(this).closest('.style-header').find('select')[0];
    if (select?.showPicker) {
      select.showPicker();
    } else {
      select.focus();
    }
  });


  $(document).on('click', '.custom-upsell-add-btn', function (e) {
    e.preventDefault();

    const $button = $(this);
    const $form = $button.closest('form');
    const variantId = $form.find('input[name="id"]').val();

    if (!variantId) {
      console.error('No variant ID found!');
      return;
    }

    $button.attr('aria-busy', 'true').prop('disabled', true);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: 1
      },
      dataType: 'json',
      success: function () {
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart }
            }));
          })
          .finally(() => {
            $button.removeAttr('aria-busy').prop('disabled', false);
          });
      },
      error: function (err) {
        console.error('Cart add error:', err);
        $button.removeAttr('aria-busy').prop('disabled', false);
      }
    });

  });

});


// // productView-ViewingProduct
// var wrapper = document.querySelector('.productView-ViewingProduct');

// if (wrapper) {
//     var numbersViewer = wrapper.getAttribute('data-customer-view');
//     var numbersViewerList = JSON.parse('[' + numbersViewer + ']');

//     var numbersViewerTime = wrapper.getAttribute('data-customer-view-time');
//     var timeViewer = parseInt(numbersViewerTime, 10) * 1000;

//     var textEl = wrapper.querySelector('.text');

//     setInterval(function () {
//         var randomIndex = Math.floor(Math.random() * numbersViewerList.length);
//         var number = numbersViewerList[randomIndex];

//         // Example fallback text if window.customer_view is undefined
//         var textTemplate = window.customer_view?.text || '[number] customers are viewing this product';

//         textEl.textContent = textTemplate.replace('[number]', number);
//     }, timeViewer);
// }

